import { render, staticRenderFns } from "./CzNace.vue?vue&type=template&id=4f236854&"
import script from "./CzNace.vue?vue&type=script&lang=js&"
export * from "./CzNace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CzNace.vue"
export default component.exports